import SidebarHeader from './SidebarHeader';

/**
 * @param {{
 *   children: import('react').ReactNode,
 *   showCloseButton?: boolean,
 *   onClose?: () => void,
 *   className?: string,
 * }} props
 */
const Sidebar = ({ children, showCloseButton = false, onClose, className = '' }) => (
  <div className={`flex h-full min-h-0 w-64 flex-col bg-white ${className}`}>
    <SidebarHeader showCloseButton={showCloseButton} onClose={onClose} />
    <div className="flex min-h-0 flex-1 flex-col">{children}</div>
  </div>
);

export default Sidebar;
